import React, { useState, useEffect } from 'react';
import {
  Box, IconButton, Menu, MenuItem, Avatar, Typography, styled,
  Drawer, List, ListItem, ListItemIcon, ListItemText
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import PeopleIcon from '@mui/icons-material/People';

// Edge function URL
const LOGOUT_URL = "https://fztfytovnyxxetzgjzxl.supabase.co/functions/v1/authentication/logout";

const HeaderContainer = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  height: '64px',
  backgroundColor: '#fff',
  borderBottom: '1px solid #e0e0e0',
  display: 'flex',
  alignItems: 'center',
  padding: '0 20px',
  zIndex: 1000
});
const LogoContainer = styled(Box)({ display: 'flex', alignItems: 'center' });
const LogoText = styled(Typography)({ fontSize: '20px', fontWeight: 600, color: '#1976d2', marginLeft: '8px' });
const HeaderActions = styled(Box)({ marginLeft: 'auto', display: 'flex', alignItems: 'center' });
const UserInfo = styled(Box)({ display: 'flex', alignItems: 'center', marginLeft: '16px', cursor: 'pointer' });
const UserName = styled(Typography)({ marginLeft: '8px', fontWeight: 500 });

function Header() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const email = localStorage.getItem('user_email');
    if (email) setUserEmail(email);
  }, []);

  const toggleDrawer = (openState) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setDrawerOpen(openState);
  };
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      if (token) {
        await axios.post(LOGOUT_URL, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
    } catch (error) {
      console.error('Error calling logout API:', error);
    } finally {
      try {
        // Clear all local and session storage
        localStorage.clear();
        sessionStorage.clear();
        // Reset is_admin
        localStorage.setItem('is_admin', 'false');
        // Clear cookies
        document.cookie.split(';').forEach(c => {
          document.cookie = c.split('=')[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
        });
      } catch (e) {
        console.error('Error clearing storage:', e);
      }
      // Redirect to login
      window.location.replace('/login');
      handleClose();
    }
  };

  const handleHome = () => navigate('/home');
  const handleProfile = () => handleClose();
  const navigateToUserConfig = () => {
    navigate('/user-configurations');
    setDrawerOpen(false);
  };

  const userName = userEmail ? userEmail.split('@')[0] : 'User';
  const avatarLetter = userName ? userName[0].toUpperCase() : 'U';

  return (
    <HeaderContainer>
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
          <List>
            <ListItem button onClick={navigateToUserConfig}>
              <ListItemIcon><PeopleIcon /></ListItemIcon>
              <ListItemText primary="User Configurations" />
            </ListItem>
          </List>
        </Box>
      </Drawer>

      <LogoContainer>
        <IconButton edge="start" onClick={toggleDrawer(true)} sx={{ mr: 1 }}>
          <MenuIcon sx={{ color: '#1976d2' }} />
        </IconButton>
        <HomeIcon sx={{ color: '#1976d2' }} />
        <LogoText>DevOps Dashboard</LogoText>
      </LogoContainer>

      <HeaderActions>
        <UserInfo onClick={handleClick}>
          <Avatar sx={{ width: 32, height: 32, bgcolor: '#1976d2' }}>{avatarLetter}</Avatar>
          <UserName variant="body2">{userName}</UserName>
        </UserInfo>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleHome}><HomeIcon fontSize="small" sx={{ mr: 1 }}/>Home</MenuItem>
          <MenuItem onClick={handleProfile}><PersonIcon fontSize="small" sx={{ mr: 1 }}/>Profile</MenuItem>
          <MenuItem onClick={handleLogout}><LogoutIcon fontSize="small" sx={{ mr: 1 }}/>Logout</MenuItem>
        </Menu>
      </HeaderActions>
    </HeaderContainer>
  );
}

export default Header;
